module.exports = __webpack_public_path__ + "img/visa.8b3c3d4e.svg";